/** Idle-timeout behaviour, storage keys, and routes where idle detection is disabled. */

import { APP_ROUTES } from "./route-paths";

export const IDLE_TIMEOUT = 300; // seconds before warning modal
export const COUNTDOWN_SECONDS = 120; // seconds to count down before session ends
export const PATIENT_NAVIGATOR_IDLE_TIMEOUT = 12 * 60 * 60; // 43200 seconds (12 hours) for Patient Navigator role

export const ACTIVITY_EVENTS: (keyof DocumentEventMap)[] = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
  "click",
];

export const IDLE_MODAL_STATES = {
  ACTIVE: "active",
  WARNING: "warning",
  CONFIRMATION: "confirmation",
  TIMEOUT: "timeout",
} as const;

// Routes where idle detection is suppressed
export const IDLE_DISABLED_ROUTES = [
  APP_ROUTES.CONTACT,
  APP_ROUTES.CONTACT_US,
  APP_ROUTES.PAGE_NOT_FOUND,
  APP_ROUTES.ERROR,
  APP_ROUTES.HEALTH_CHECK,
  APP_ROUTES.APPOINTMENT_CONFIRMED,
] as string[];

export const LOCAL_STORAGE_KEYS = {
  FIND_MEMBER_ID_MODAL: "obc-find-member-id-modal",
  LAST_PAGE_URL: "lastpageURL",
  COMPLETION_STATUS: "completionStatus",
} as const;

export const SESSION_STORAGE_KEYS = {
  CONFIRMED_BACK: "obc-confirmed-back",
  CONFIRMED_BACK_ROUTE: "obc-confirmed-back-route",
  CONFIRMED_BACK_RELOAD_ROUTE: "obc-confirmed-back-reload-route",
  PATIENT_INFO_UNLOAD_REDIRECT: "obc-patient-info-unload-redirect",
} as const;
